import { globalLogger } from '../../../qaamgo/helper/global-logger';
import { AjaxWrapper } from '../../../lib/ajax/ajax-wrapper';
import { satGlobals } from '../../../qaamgo/sat/helper/sat-globals';
import 'bootstrap/js/dist/popover';
import { testIsNonEmptyString } from '../../../lib/test-and-assert/test-base';

/**
 * Returns the number of selected files
 *
 * @returns {jQuery}
 * @private
*/
var _getNumberOfSelectedFiles = function () {
    return $('.file-checkbox:checked').length;
};

/**
 * generates the query string based on the selected files
 *
 * @returns {string}
 * @private
 */
var _getQueryParameter = function () {
    var urls = [];
    $('.file-checkbox:checked').each(function (index) {
        urls.push('remote_url[]=' + $(this).val());
    });

    return urls.join('&');
};

/**
 * @param {string} location
 * @private
 */
var _redirectWithStorage = function (location, url = '') {
    var urls = [];

    if(url) {
        urls.push({ url: url });
    } else {
        $('.file-checkbox:checked').each(function (index) {
            let url = $(this).val();
            urls.push({ url: url });
        });
    }

    let ajaxWrapper = new AjaxWrapper();
    ajaxWrapper
        .postJson({
            url: satGlobals.getApiUrl('api/storage/url'),
            dataType: 'json',
            data: urls,
            xhrFields: {
                withCredentials: true,
            },
            cache: false,
            maxRetries: 3,
        })
        .done(function (response) {
            const tabUrl = location + '#su=' + response.id;
            window.open(tabUrl, '_blank');
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            globalLogger.log('url storage reconvert - fail - connection problem', {
                http_status: jqXHR.status,
                ajax_status: textStatus,
                ajax_error: errorThrown,
            });
        });
};

/**
 * Forwards to a new url with a POST request. This is done in JS by creating
 * a new hidden form. See this answer for details: https://stackoverflow.com/a/23347795
 *
 * @param {string} location
 * @private
 */
var _redirectWithPost = function (location) {
    var form = $('<form></form>');
    form.attr('method', 'post');
    form.attr('action', location);

    $('.file-checkbox:checked').each(function (index) {
        var url = $(this).val();

        var field = $('<input></input>');

        field.attr('type', 'hidden');
        field.attr('name', 'remote_url[' + index + ']');
        field.attr('value', url);

        form.append(field);
    });

    $(form).appendTo('body').submit();
};

/**
 * Forwards to a new url with a POST request for inputs. This is done in JS by creating
 * a new hidden form. See this answer for details: https://stackoverflow.com/a/23347795
 *
 * @param {string} location
 * @private
 */
var _redirectWithPostInput = function (location) {
    var form = $('<form></form>');
    form.attr('method', 'post');
    form.attr('action', location);

    var field = $('<input></input>');

    field.attr('type', 'hidden');
    field.attr('name', 'input_job');
    field.attr('value', backJob);

    form.append(field);

    $(form).appendTo('body').submit();
};

var _updateReconvertUi = function (selectedCount) {
    try {
        var popoverConfig = {
            content: '',
            placement: 'top',
            trigger: 'hover',
            template:
                '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
        };

        $('.tile-link').popover('hide').popover('disable').popover('dispose');

        $('.popover').remove();

        $.each($('.tile-link'), function () {
            $(this).prop('title', $(this).data('original-title'));
        });

        if (selectedCount === 0) {
            popoverConfig.content = window.qgResultConfig.translations.reconvertNoneSelected;

            $('.reconvert-button-list .tile').addClass('tile-disabled').parent('.tile-link').popover(popoverConfig);

            return;
        }

        if (selectedCount > 50) {
            popoverConfig.content = window.qgResultConfig.translations.reconvertTotalInputLimitReached;

            $('.reconvert-button-list .tile').addClass('tile-disabled').parent('.tile-link').popover(popoverConfig);
        }

        if (selectedCount > 1) {
            popoverConfig.content = window.qgResultConfig.translations.reconvertSingleFileLimit;

            $('.singleFile .tile').addClass('tile-disabled').parent('.tile-link').popover(popoverConfig);
        }
    } catch (e) {
        globalLogger.log('reconvert fail exception', e);
    }
};

/**
 * Setup for the reconvert buttons
 *
 * @param {RawJobInfo} job
 */
var _setupReconvert = function (job) {
    var USE_POST = true;

    const hasRedoLink = testIsNonEmptyString(job?.sat_links?.redo?.href?.link);

    if (!hasRedoLink || job?.sat?.operation === 'createpdf') {
        $('.convert-again-btn').addClass('hidden');
    }

    if (hasRedoLink) {
        $('.convert-again-btn').on('click', function (e) {
            e.preventDefault();

            window.location.href = job.sat_links.redo.href.link + '#j=' + job.sat.hierarchy.path[0].id;
        });
    } else {
        globalLogger.log(
            '_setupReconvert :: no reconvert link',
            JSON.stringify({
                operation: job?.sat?.operation ? job?.sat?.operation : '',
            })
        );
    }

    $('.reconvert-input').on('click', function (e) {
        e.preventDefault();

        if ($(this).find('.tile-disabled').length > 0) {
            return;
        }

        var url = '/';

        if (USE_POST) {
            _redirectWithStorage(url);

            return;
        }

        var query = _getQueryParameter();
        window.open(url + '?' + query);
    });

    var config = {};

    const hasReconvertLinks = Array.isArray(job?.sat_links?.reconvert) && job.sat_links.reconvert.length > 0;

    if (hasReconvertLinks) {
        $.each(job.sat_links.reconvert, function (id, buttonConfig) {
            if (!testIsNonEmptyString(buttonConfig.operation) || !testIsNonEmptyString(buttonConfig?.href?.link)) {
                return;
            }

            let operation = 'reconvert' + buttonConfig.operation;
            config[operation] = {
                url: buttonConfig.href.link,
                singleFile: !buttonConfig.multifile,
            };
        });
    }

    /**
     * config = {
     *     'buttonId': {
     *         'url': 'string',
     *         'singleFile': 'bool'
     *     }
     * };
     */
    $.each(config, function (buttonId, buttonConfig) {
        if (buttonConfig.singleFile) {
            $('#' + buttonId).addClass('singleFile');
        }

        $('.reconvert-button-list').on('click', '#' + buttonId, function (e) {
            e.preventDefault();

            if ($(this).find('.tile-disabled').length > 0) {
                return;
            }

            var url = buttonConfig.url;

            if (USE_POST) {
                _redirectWithStorage(url);

                return;
            }

            var query = _getQueryParameter();
            window.open(url + '?' + query);
        });

        $('.reconvert-button').on('click', '#' + buttonId, function (e) {
            e.preventDefault();

            if ($(this).find('.tile-disabled').length > 0) {
                return;
            }

            var url = buttonConfig.url;

            if (USE_POST) {
                _redirectWithStorage(url);

                return;
            }

            var query = _getQueryParameter();
            window.open(url + '?' + query);
        });
    });

    _updateReconvertUi(job.output.length);

    $(document).on('click', '#select-all-checkbox-top, #select-all-checkbox-bottom', function () {
        $('#file-select-all').click();
    });

    $(document).on(
        'click',
        '.file-checkbox, #select-all-checkbox-top, #select-all-checkbox-bottom, #file-select-all',
        function () {
            $('.tile').removeClass('tile-disabled');

            _updateReconvertUi(_getNumberOfSelectedFiles());
        }
    );
};

var satReconvert = {
    setup: _setupReconvert,
    redirectWithStorage: _redirectWithStorage
};

export { satReconvert };
